import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
@Component({
  selector: "myqq-account-setup-modal",
  templateUrl: "./account-setup-modal.component.html",
  styleUrls: ["./account-setup-modal.component.scss"],
})
export class AccountSetupModalComponent implements OnInit {
  processing = false;
  constructor(readonly dialogRef: MatDialogRef<AccountSetupModalComponent>) {}
  ngOnInit(): void {
    this.dialogRef.addPanelClass("myqq-alert-dialog");
  }
  selectedMember() {
    if (!this.processing) {
      this.processing = true;
      this.dialogRef.close({ member: true });
    }
  }
  selectedNonMember() {
    if (!this.processing) {
      this.processing = true;
      this.dialogRef.close({ member: false });
    }
  }
}
